import { MapTo, withComponentMappingContext } from '@adobe/aem-react-editable-components';

import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
import { withRoute } from '@yme/components/RouteHelper/RouteHelper';

import PartnerDetailsPage from './PartnerDetailsPage';

export default MapTo(AEM_FUNCTIONS.partnerDetailsPage)(
  withComponentMappingContext(withRoute(PartnerDetailsPage)),
);
